"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var spacesGroup = /\x09-\x0D\x20\x85\xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000/;
exports.default = spacesGroup;
module.exports = exports["default"];